import DownloadFiles from "./Modal"

export default DownloadFiles